<template>
    <div
        :class="{
            [$style.wrapper]: true,
            [$style.hover]: hover,
        }"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
    >
        <div :class="$style.layout">
            <input
                v-if="editMode"
                v-model="editText"
                type="text"
                style="width: auto"
            />
            <!-- eslint-disable vue/no-v-html -->
            <div
                v-else
                :class="$style.viewText"
                :title="text"
                v-html="viewText"
            />

            <div v-if="showControls" :class="$style.controls">
                <template v-if="editMode">
                    <i
                        class="fa-solid fa-times"
                        title="Cancel"
                        @click="cancelEdit"
                    />
                    <i class="fa-solid fa-save" title="Save" @click="save" />
                </template>
                <template v-else>
                    <i
                        class="fa-solid fa-pencil-alt"
                        title="Edit"
                        @click="beginEdit"
                    />
                    <i
                        class="fa-solid fa-trash-alt"
                        title="Delete"
                        @click="$emit('delete', id)"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: Number,
        text: String,
    },
    data() {
        return {
            hover: false,
            editMode: false,
            editText: '',
        };
    },
    computed: {
        showControls() {
            return this.hover || this.editMode;
        },
        viewText() {
            return this.text.replace(
                /(https?:\/\/[\S]*)/,
                `<a target="_blank" href="$1">$1</a>`,
            );
        },
    },
    methods: {
        beginEdit() {
            this.editText = this.text;
            this.editMode = true;
        },
        cancelEdit() {
            this.editMode = false;
        },
        save() {
            this.editMode = false;
            this.$emit('update', this.id, this.editText);
        },
    },
};
</script>

<style lang="scss" module>
.wrapper {
    &.hover {
        background-color: #f0f0f0;
        border-radius: 3px;
    }
    .layout {
        display: grid;
        grid-gap: 0;
        grid-template-columns: [col] auto [col] 50px;
        grid-template-rows: [row] auto;
        width: 100%;
    }
}
input {
    padding: 0;
    margin: 0;
}
.viewText {
    padding: 3px;
    overflow: hidden;
    vertical-align: middle;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.controls {
    text-align: right;
    padding-top: 3px;

    i {
        font-size: 12pt;
        color: #666;
        padding-left: 3px;
        padding-right: 3px;

        &:hover {
            cursor: pointer;
            color: #222;
        }
    }
}
</style>
